import React from "react"

const OrionDownload = () => {
  const class1 = {
    fill: "none",
    stroke: "#3f5063",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
  }
  return (
    <svg viewBox="0 0 44 70">
      <g id="Orion_file" transform="translate(1 1)">
        <path
          id="Shape"
          className="cls-1"
          style={class1}
          d="M4,0A4,4,0,0,0,0,4V56a4,4,0,0,0,4,4H38a4,4,0,0,0,4-4V16L26,0Z"
        />
        <path
          id="Shape-2"
          data-name="Shape"
          style={class1}
          d="M0,0V12a4,4,0,0,0,4,4H16"
          transform="translate(26)"
        />
        <path
          id="PDF"
          className="cls-2"
          fill="#6ec18a"
          d="M23.618,10H21.782V0H29V1.557H23.618V4.6h4.774V6.171H23.618V10Zm-9.182,0H10.114V0h4.322a6.181,6.181,0,0,1,2.812.621,4.608,4.608,0,0,1,1.907,1.758A5.031,5.031,0,0,1,19.832,5a5.03,5.03,0,0,1-.678,2.621,4.6,4.6,0,0,1-1.907,1.758A6.181,6.181,0,0,1,14.436,10ZM11.95,1.571V8.429h2.4a4.173,4.173,0,0,0,1.914-.421,3.008,3.008,0,0,0,1.272-1.2A3.593,3.593,0,0,0,17.982,5a3.6,3.6,0,0,0-.445-1.807,3.008,3.008,0,0,0-1.272-1.2,4.173,4.173,0,0,0-1.914-.421ZM1.836,10H0V0H4.068A5.447,5.447,0,0,1,6.307.428,3.28,3.28,0,0,1,7.769,1.657a3.482,3.482,0,0,1,.509,1.9A3.492,3.492,0,0,1,7.769,5.45,3.269,3.269,0,0,1,6.307,6.686a5.447,5.447,0,0,1-2.239.428H1.836V10Zm0-8.429V5.543H3.983a2.8,2.8,0,0,0,1.823-.515,1.809,1.809,0,0,0,.621-1.472,1.809,1.809,0,0,0-.621-1.471,2.818,2.818,0,0,0-1.823-.514Z"
          transform="translate(7 44)"
        />
        <path
          id="Path"
          className="cls-2"
          fill="#6ec18a"
          d="M12.343,12.052l.35.306a.853.853,0,0,1,0,1.31L7.529,19.3v.044l-.35.349a1.007,1.007,0,0,1-.35.24A1.118,1.118,0,0,1,6.434,20a1.181,1.181,0,0,1-.372-.066.668.668,0,0,1-.328-.24l-.35-.349V19.3L.306,13.755a1.053,1.053,0,0,1,0-1.485l.35-.218a.853.853,0,0,1,.722-.262,1.17,1.17,0,0,1,.722.349l2.976,3.319V1.4A1.379,1.379,0,0,1,5.471.415,1.327,1.327,0,0,1,6.478,0a1.348,1.348,0,0,1,.985.415,1.341,1.341,0,0,1,.416.983V15.459l3.064-3.406a.989.989,0,0,1,.722-.306A.853.853,0,0,1,12.343,12.052Z"
          transform="translate(14 14)"
        />
      </g>
    </svg>
  )
}

export default OrionDownload
